"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseUrl = exports.setBaseUrl = exports.getAccessToken = exports.setAccessToken = exports.getHeader = exports.setHeader = exports.getValidValue = void 0;
var base_1 = require("./base");
exports.getValidValue = function (value) {
    if (!value) {
        return null;
    }
    var invalidValues = ['', 'null', 'undefined'];
    if (invalidValues.some(function (v) { return v === value.trim(); })) {
        return null;
    }
    return value;
};
exports.setHeader = function (instance, key, value) {
    var validValue = exports.getValidValue(value);
    if (validValue) {
        instance.defaults.headers.common[key] = validValue;
    }
    else {
        delete instance.defaults.headers.common[key];
    }
};
exports.getHeader = function (instance, key) { return instance.defaults.headers.common[key] || null; };
exports.setAccessToken = function (instance, token) {
    var validValue = exports.getValidValue(token);
    if (validValue) {
        instance.defaults.headers.common[base_1.Header.AUTHORIZATION] = "Bearer " + validValue;
    }
    else {
        delete instance.defaults.headers.common[base_1.Header.AUTHORIZATION];
    }
};
exports.getAccessToken = function (instance) {
    var token = instance.defaults.headers.common[base_1.Header.AUTHORIZATION];
    if (token) {
        return token.split(' ')[1];
    }
    return null;
};
exports.setBaseUrl = function (instance, url) {
    var validValue = exports.getValidValue(url);
    if (validValue) {
        instance.defaults.baseURL = validValue;
    }
    else {
        throw Error("BaseUrl was attempted set to invalid value: " + url + ".");
    }
};
exports.getBaseUrl = function (instance) { return instance.defaults.baseURL; };
//# sourceMappingURL=utils.js.map